import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueFullPage from 'vue-fullpage.js'
import axios from 'axios'

Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.use(VueFullPage)

// vue-session 설정
import VueSession from 'vue-session'
Vue.use(VueSession, {persist: true})

// 전역 컴포넌트 등록
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
const requireComponent = require.context(
  './components/common', false, /.vue$/
)

Vue.prototype.$http = axios

requireComponent.keys().forEach(fileName => {
// Get component config
  const componentConfig = requireComponent(fileName)
// Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )
// Register component globally
  Vue.component(componentName, componentConfig.default || componentConfig)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
